import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { newAssignmentParams } from '../lib/callLists';
import { usePagedList } from './usePagedList';

const KEY = 'mobile-new-assignments';

/**
 * The calls assigned to the signed-in member that nobody has started, for
 * the mobile shell's assigned-call prompt. Asked again on every return to
 * the page, as well as on the app's 30-second poll, so a driver coming back
 * to the phone is asked at once.
 */
export function useNewAssignments<Item>({ enabled }: { enabled: boolean }) {
  return usePagedList<Item>(KEY, '/calls', newAssignmentParams(), {
    enabled,
    staleTime: 0,
  });
}

/**
 * Ask the server now, as a push for a new assignment does: the prompt's
 * calls, and the lists the new call belongs in, the calls tab and Home's.
 * Only the prompt was asked, so the call it announced was missing from the
 * list behind it until the 30-second poll came round.
 */
export function useCheckNewAssignments() {
  const queryClient = useQueryClient();
  return useCallback(() => {
    for (const key of [KEY, 'mobile-calls', 'driver-calls']) {
      void queryClient.invalidateQueries({ queryKey: [key] });
    }
  }, [queryClient]);
}
